import type { PropsWithChildren, ReactNode } from "react"
import { useState } from "react"
import { AccordionProvider } from "./AccordionProvider"
import { useAccordionContext } from "./useAccordionContext"
import { AccordionArrowIcon } from "../../icons"

interface IProps {
  type?: "flush" | "open" | "collapse"
  className: string
}

/**
 * @deprecated Legacy accordion. New code uses `CAccordionCompound` (Radix; `<CAccordionCompound.Item>`,
 * `.Trigger`, `.Content`). Existing usages are baselined in eslint-suppressions.json; migrate when touching the screen.
 */
export const CAccordion = ({ children, type = "open", className }: PropsWithChildren<IProps>) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <AccordionProvider value={{ isOpen, setIsOpen, type }}>
      <div className={className}>{children}</div>
    </AccordionProvider>
  )
}

/**
 * @deprecated Legacy accordion. New code uses `CAccordionCompound` (Radix; `<CAccordionCompound.Item>`,
 * `.Trigger`, `.Content`). Existing usages are baselined in eslint-suppressions.json; migrate when touching the screen.
 */
export const CAccordionTitle = ({
  children,
  className,
  arrowClassName,
  arrowPosition = "right",
}: PropsWithChildren<{
  children?: ReactNode | undefined
  className: string
  arrowPosition?: "left" | "right"
  arrowClassName?: string
}>) => {
  const { setIsOpen, isOpen } = useAccordionContext()

  return (
    <div className="w-full">
      <button
        color="blue"
        onClick={() => (setIsOpen as (isOpen: boolean) => void)(!isOpen)}
        type="button"
        className={`flex items-center justify-between w-full font-medium text-left text-gray-500 ${className}`}
      >
        {arrowPosition === "left" && (
          <AccordionArrowIcon
            className={`shrink-0 ${isOpen ? "" : "rotate-180"} ${arrowClassName}`}
            size={12}
          />
        )}
        <div className="w-full">{children}</div>
        {arrowPosition === "right" && (
          <AccordionArrowIcon
            className={`shrink-0 ${isOpen ? "" : "rotate-180"} ${arrowClassName}`}
            size={12}
          />
        )}
      </button>
    </div>
  )
}

/**
 * @deprecated Legacy accordion. New code uses `CAccordionCompound` (Radix; `<CAccordionCompound.Item>`,
 * `.Trigger`, `.Content`). Existing usages are baselined in eslint-suppressions.json; migrate when touching the screen.
 */
export const CAccordionContent = ({
  children,
  className,
}: PropsWithChildren<{ children?: ReactNode | undefined; className: string }>) => {
  const { isOpen } = useAccordionContext()

  return (
    <div className={`${isOpen ? "" : "hidden"} ${className}`}>
      <div className="border border-b-0 border-gray-200">{children}</div>
    </div>
  )
}
